<template lang="pug">
  v-container#list.pr-0(fluid)
    v-flex(xs12)
      v-card(flat)
        v-card-text.pb-0.small Busca palabras:
        v-card-title.py-0.searchbar
          v-text-field.px-3.search(
            v-model="search"
            append-icon="search"
            placeholder="Filtra los folios por palabra clave"
            hide-details
            class="input-group--focused"
          )
          v-card-actions
            v-btn.add(
              fab
              dark
              @click="setCreateForm"
            )
              v-icon(dark) add
        v-data-table(
          :headers="headers"
          :items="reportsForTable"
          :search="search"
          :pagination.sync="pagination"
          :custom-sort="customSort"
          expand
        )
          template(
            slot="items"
            slot-scope="props"
          )
            tr(ref="tr" @click="setRecord(props.item)" v-bind:class="{ disabled: !props.item.public }")
              td.bold.px-1 {{ counter(props.index + 1) }}
              td.bold.px-1 {{ props.item.folioId }}
              td.text-xs-left.gray-text.px-1 {{ props.item["updateDate"].toLocaleString() }}
              td.text-xs-left.gray-text.px-1 {{ props.item["created_at"].toLocaleString() }}
              td.text-xs-left.px-1 {{ props.item.state }}
              td.text-xs-left.px-1 {{ props.item.types}}
              td.text-xs-left.px-1
                v-layout(row wrap)
                  v-flex(d-flex xs2 align-center v-for="(review, index) in props.item.reviews.slice(-3)" :key="`a${index}`")
                    img.review-icon(v-if="review.changes === 'La postal es correcta'", src="/static/check.svg")
                    img.review-icon(v-else, src="/static/cross.svg")
          v-alert(
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          ) No se encontraron resultados.
</template>
<script>
export default {
  name: "List",
  props: {},
  data() {
    return {
      user: this.$store.state.user,
      search: "",
      pagination: {
        rowsPerPage: 15,
        page: 1
      },
      headers: [
        {
          text: "No.",
          align: "left",
          value: "numberList",
          sortable: false
        },
        { text: "Contexto", value: "folioId" },
        { text: "Última actualización", value: "updateDate" },
        { text: "Fecha de creación", value: "created_at" },
        { text: "Estado", value: "state" },
        { text: "Agresión", value: "types" },
        { text: "Revisión", value: "reviews" }
      ]
    };
  },
  computed: {
    reports() {
      return this.$store.getters.reports;
    },
    reportsForTable() {
      let reports = this.reports;

      reports.forEach(report => {
        report.folioId = report.context ? report.context.contextId : "";
        if (report.aggression_type) {
          report.types = report.aggression_type.join(", ");
          const date = new Date(report.updated_at);
          report.updateDate = date;
          const createDate = new Date(report.created_at);
          report.created_at = createDate;
        }
      });
      return reports;
    }
  },
  methods: {
    setCreateForm() {
      this.$store.commit("setEditionState", false);
      this.$store.commit("resetRecord");
      this.$router.replace("/form");
    },
    setRecord(record) {
      // console.log(record)
      //this.$refs.tr.classList.toggle('selected')
      if (
        this.user.role === "admin" ||
        this.user.role === "Administración" ||
        record.public === true
      ) {
        this.$store.commit("setRecord", record);
      }
    },
    getReports() {
      this.$store.dispatch("getReports");
    },
    counter(index) {
      let start = this.pagination.page * 15 - 15;
      let rowNumber = start + index;
      return rowNumber;
    },
    customSort: (items, index, isDesc) => {
      items.sort((a, b) => {
        if (index == "updateDate" || index == "created_at") {
          if (!isDesc) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else if (index == "reviews") {
          if (!isDesc) {
            return a[index][0] && a[index][0]["changes"] ? -1 : 1;
          } else {
            return a[index][0] && a[index][0]["changes"] ? 1 : -1;
          }
        } else {
          if (typeof a[index] !== "undefined") {
            if (!isDesc) {
              return a[index]
                .toLowerCase()
                .localeCompare(b[index].toLowerCase());
            } else {
              return b[index]
                .toLowerCase()
                .localeCompare(a[index].toLowerCase());
            }
          }
        }
      });
      return items;
    }
  },
  mounted() {
    this.getReports();
  }
};
</script>
<style src="./list.scss" lang="scss">
</style>
